var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcPlayLarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EBBED384-A035-4FB2-B3C5-F2B064BD0C8F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e-apm\\u0101c\\u012Bba",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03.-E---apm\\u0101c\\u012Bba---Atv\\u0113rta-nodarb\\u012Bba",
    transform: "translate(-829.000000, -448.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(294.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Video-block",
    transform: "translate(24.000000, 112.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button",
    transform: "translate(511.000000, 266.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "path",
    fill: "#059DC1",
    cx: 50,
    cy: 50,
    r: 50
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path",
    fill: "#FFFFFF",
    points: "42 33 42 67 68 50.4857143"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlayLarge);
export default __webpack_public_path__ + "static/media/ic-play-large.c05e7a253adfa791bd137e8967d74a18.svg";
export { ForwardRef as ReactComponent };